import { removeLoginSessionByToken } from '../http'
import { axios } from './axios'
import userManager from './UserManager'

export const activeAccessToken: { exp: number; token: string } = {
  token: null,
  exp: null,
} as const

export const X_CLIENT_HEADER = 'X-Client-Id'
export const X_BOAT_HEADER = 'X-Boat-Id'

export function setAxiosBoatHeader(boatId: number) {
  axios.defaults.headers[X_BOAT_HEADER] = boatId
}

export function setAxiosClientHeader(clientId: number) {
  axios.defaults.headers[X_CLIENT_HEADER] = clientId
}

export function clearAxiosClientHeader() {
  axios.defaults.headers[X_CLIENT_HEADER] = undefined
}

export function clearAxiosBoatHeader() {
  axios.defaults.headers[X_BOAT_HEADER] = undefined
}

export function setAxiosAuthHeader(token: string) {
  axios.defaults.headers['Authorization'] = 'Bearer ' + token
}

export function setActiveAccessToken(token: string, exp: number) {
  try {
    activeAccessToken.token = token
    activeAccessToken.exp = exp
    setAxiosAuthHeader(token)
  } catch (e) {
    console.log('Error parsing login')
    console.error(e)
    return
  }
}

export async function getActiveRefreshToken() {
  const userDetails = await userManager.getUser()
  return userDetails?.refresh_token
}
export async function getActiveAccessToken() {
  const userDetails = await userManager.getUser()
  return userDetails?.access_token
}

export function clearActiveAccessToken() {
  activeAccessToken.token = null
  activeAccessToken.exp = null
  clearAxiosAuthHeader()
}

export function clearRefreshTokenAndSession() {
  const token = localStorage.getItem('refresh-token')
  if (token === null) return

  localStorage.removeItem('refresh-token')

  return removeLoginSessionByToken(token)
}

export function clearAxiosAuthHeader() {
  delete axios.defaults.headers['Authorization']
}

export async function getUserFromStorage() {
  const user = await userManager.getUser()

  try {
    return user
  } catch {
    console.error('Failed parsing user')
  }
}
